module.exports = __webpack_public_path__ + "img/icbc.99de80b3.jpg";